import React, { createContext, useState } from 'react'
import { RTL_LOCALES } from '../utils/constants'

export const DirectionContext = createContext({
  isRTL: false,
  toggleDirection: () => {}
})

export const checkRTL = locale => {
  if (!locale) return false
  return RTL_LOCALES.has(locale.toLowerCase())
}

const DirectionProvider = ({ children }) => {
  const [isRTL, setIsRTL] = useState(false)
  const toggleDirection = goRTL => {
    setIsRTL(goRTL)
  }
  return (
    <DirectionContext.Provider value={{ isRTL, toggleDirection }}>
      {children}
    </DirectionContext.Provider>
  )
}

export default DirectionProvider
